var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "500",
      "title": _vm.semiItem.material ? _vm.semiItem.material.model : ''
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-wrap"
  }, [_c('div', {
    staticClass: "drawer-contetn"
  }, [_c('div', {
    staticClass: "basic-info"
  }, [_c('h3', {
    staticClass: "basicInfo-item mlName"
  }, [_vm._v(" " + _vm._s(_vm.semiItem.material ? _vm.semiItem.material.model + "-" + _vm.semiItem.material.name : "") + " ")]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("配方名称")]), _c('div', [_vm._v(" " + _vm._s(_vm.currentMLLatestCost.recipeSemi ? _vm.currentMLLatestCost.recipeSemi.name : "") + " ")])]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("创建时间")]), _c('div', [_vm._v(" " + _vm._s(_vm.currentMLLatestCost.recipeSemi ? _vm.currentMLLatestCost.recipeSemi.createdAt : "") + " ")])]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("配方创建者")]), _c('div', [_vm._v(" " + _vm._s(_vm.currentMLLatestCost.recipeSemi ? _vm.currentMLLatestCost.recipeSemi.createdBy.name : "") + " ")])]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("生产工厂")]), _c('div', [_vm._v(" " + _vm._s(_vm.semiItem.factory ? _vm.semiItem.factory.name : "") + " ")])]), _c('div', {
    staticClass: "basicInfo-item materialCost"
  }, [_c('div', [_vm._v("材料成本")]), _c('div', [_vm._v(_vm._s(parseInt(_vm.currentMLLatestCost.materialCost)))])]), _c('div', {
    staticClass: "basicInfo-item manufactCost"
  }, [_c('div', [_vm._v("合成加工费")]), _c('div', [_vm._v(_vm._s(_vm.currentMLLatestCost.manufactCost))])]), _c('div', {
    staticClass: "basicInfo-item materialAddManufact"
  }, [_c('div', [_vm._v("材料+制造合计")]), _c('div', [_vm._v(" " + _vm._s(parseInt(_vm.currentMLLatestCost.manufactCost + _vm.currentMLLatestCost.materialCost)) + " ")])]), _c('div', {
    staticClass: "basicInfo-item tranCost"
  }, [_c('div', [_vm._v("运费")]), _c('div', [_vm._v(" " + _vm._s(_vm.currentMLLatestCost.importSemiTransCost ? _vm.currentMLLatestCost.importSemiTransCost : "-") + " ")])]), _c('div', {
    staticClass: "basicInfo-item totalCost"
  }, [_c('div', [_vm._v("总成本")]), _c('div', [_vm._v(_vm._s(parseInt(_vm.currentMLLatestCost.totalCost)))])]), _c('div', {
    staticClass: "basicInfo-item totalCost"
  }, [_c('div', [_vm._v("固含量")]), _c('div', [_vm._v(_vm._s(_vm.currentMLLatestCost.solidContent.toFixed(2) + "%"))])]), _c('div', {
    staticClass: "basicInfo-item totalCost"
  }, [_c('div', [_vm._v("单个固含成本")]), _c('div', [_vm._v(" " + _vm._s(_vm.currentMLLatestCost.unitCostPerSoidContent.toFixed(2)) + " ")])])]), _c('div', {
    staticClass: "cost"
  }), _c('div', {
    staticClass: "material-table"
  }, [_c('Table', {
    attrs: {
      "border": "",
      "loading": _vm.materialTableLoading,
      "columns": _vm.materialTableColumns,
      "data": _vm.currentMLLatestCost.materialCostDetail
    }
  })], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }